import { render, staticRenderFns } from "./ClassicCaseView.vue?vue&type=template&id=bbfba620"
import script from "./ClassicCaseView.vue?vue&type=script&lang=js"
export * from "./ClassicCaseView.vue?vue&type=script&lang=js"
import style0 from "./ClassicCaseView.vue?vue&type=style&index=0&id=bbfba620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports